import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { useAppDispatch } from '../../../../redux/hooks';
import { toggleDarkMode } from '../../../../redux/slices/settingsSlice';

export const useDarkTheme = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const dispatch = useAppDispatch();
  const [isChecked, setIsChecked] = useState<boolean>(
    !document.documentElement.classList.contains('dark')
  );
  const [isFirstMount, setIsFirstMount] = useState(true);

  useEffect(() => {
    if (!isFirstMount) {
      if (!isChecked) {
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
        dispatch(toggleDarkMode(true));
      } else {
        document.documentElement.classList.remove('dark');
        document.documentElement.classList.add('light');
        dispatch(toggleDarkMode(false));
      }
    } else {
      if (document.documentElement.classList.contains('dark')) {
        setIsChecked(false);
        dispatch(toggleDarkMode(true));
      } else if (document.documentElement.classList.contains('light')) {
        setIsChecked(true);
        dispatch(toggleDarkMode(false));
      } else {
        setIsChecked(false);
        dispatch(toggleDarkMode(true));
      }
      setIsFirstMount(false);
    }
  }, [isChecked, isFirstMount]);

  return [isChecked, setIsChecked];
};
